import { createAction, props } from "@ngrx/store";
import { APIResponse } from "src/app/core/models/api-response";
import { IInventoryFilter, IInventoryFilterRequest, IProduct, IProductCatalogsData, IProductCompany, IProductInventoryDetails, IProductOrdersKPI, IVariant } from "../models/products.models";
import { IPageCount } from "src/app/shared/models/page.model";

// fetch all products
export const FetchAllProducts = createAction(
  '[ Products ] - FetchAllProducts'
);
export const FetchAllProductsSuccess = createAction(
  '[ Products ] - FetchAllProducts Success ',
  props<{ products: APIResponse<IProduct> }>()
);

export const FetchAllProductsError = createAction(
  '[ Products ] - FetchAllProduct Error',
);

// fetch products
export const FetchProducts = createAction(
  '[ Products ] - FetchProducts',
  props<{
    page: IPageCount;
    filter?: IInventoryFilterRequest | undefined;
    key?: string | undefined;
    sort_by?: string;
    sort_mode?: string,
    priority?: number[] | undefined
  }>()
);
export const FetchProductsSuccess = createAction(
  '[ Products ] - FetchProducts Success ',
  props<{ products: APIResponse<IProduct> }>()
);

export const FetchProductsError = createAction(
  '[ Products ] - FetchProduct Error',
);

// get product by id
export const GetProductById = createAction(
  '[ Product ] - GetProductById',
  props<{ id?: number }>()
);
export const GetProductByIdSuccess = createAction(
  '[ Product ] - GetProductById Success ',
  props<{ product: IProduct }>()
);
export const GetProductByIdError = createAction(
  '[ Product ] - GetProductById Error',
);

// get product inventory details
export const GetProductInventoryDetails = createAction(
  '[ Product ] - GetProductInventoryDetails',
  props<{ id?: number }>()
);
export const GetProductInventoryDetailsSuccess = createAction(
  '[ Product ] - GetProductInventoryDetails Success ',
  props<{ inventoryDetails: APIResponse<IProductInventoryDetails> }>()
);
export const GetProductInventoryDetailsError = createAction(
  '[ Product ] - GetProductInventoryDetails Error',
);

// get product companies
export const GetProductCompanies = createAction(
  '[ Product Companies ] - GetProductCompanies',
  props<{ id?: number }>()
);
export const GetProductCompaniesSuccess = createAction(
  '[ Product Companies ] - GetProductCompanies Success ',
  props<{ productCompanies: APIResponse<IProductCompany> }>()
);
export const GetProductCompaniesError = createAction(
  '[ Product Companies ] - GetProductCompanies Error',
);

// get product orders kpi
export const GetProductOrdersKPI = createAction(
  '[ Product Orders KPI ] - GetProductOrdersKPI',
  props<{ id?: number }>()
);
export const GetProductOrdersKPISuccess = createAction(
  '[ Product Orders KPI ] - GetProductOrdersKPI Success ',
  props<{ productOrdersKPI: APIResponse<IProductOrdersKPI> }>()
);
export const GetProductOrdersKPIError = createAction(
  '[ Product Orders KPI ] - GetProductOrdersKPI Error',
);

// clear product orders kpi
export const ClearKpisProduct = createAction(
  '[ Product Orders KPI ] - ClearKpisProduct',
);

// clear product inventory details
export const ClearProductInventoryDetails = createAction(
  '[ Product Inventory Details ] - ClearProductInventoryDetails',
);

// add product
export const AddProduct = createAction(
  '[ Product ] - AddProduct',
  props<{ product: IProduct }>()
);
export const AddProductSuccess = createAction(
  '[ Product ] - AddProduct Success ',
  props<{ product: IProduct }>()
);
export const AddProductError = createAction(
  '[ Product ] - AddProduct Error',
);

// update product
export const UpdateProduct = createAction(
  '[ Product ] - UpdateProduct',
  props<{ id?: number, product: IProduct }>()
);
export const UpdateProductSuccess = createAction(
  '[ Product ] - UpdateProduct Success ',
  props<{ product: IProduct }>()
);
export const UpdateProductError = createAction(
  '[ Product ] - UpdateProduct Error',
);

// delete product
export const DeleteProduct = createAction(
  '[ Product ] - DeleteProduct',
  props<{ id?: number}>()
);
export const DeleteProductSuccess = createAction(
  '[ Product ] - DeleteProduct Success '
);
export const DeleteProductError = createAction(
  '[ Product ] - DeleteProduct Error',
);

// Delete multiple products
export const DeleteProducts = createAction(
  '[ Products ] - DeleteProducts',
  props<{ product_ids: number[] }>()
);
export const DeleteProductsSuccess = createAction(
  '[ Products ] - DeleteProducts Success ',
);
export const DeleteProductsError = createAction(
  '[ Products ] - DeleteProducts Error',
);

// add product with variants
export const AddProductWithVariants = createAction(
  '[ Product ] - AddProductWithVariants',
  props<{ product: Omit<IProduct, 'sku'> }>()
);
export const AddProductWithVariantsSuccess = createAction(
  '[ Product ] - AddProductWithVariants Success ',
  props<{ product: IProduct }>()
);
export const AddProductWithVariantsError = createAction(
  '[ Product ] - AddProductWithVariants Error',
);

//  Update variants of product
export const UpdateVariantsProduct = createAction(
  '[ Product ] - UpdateVariantsProduct',
  props<{ id: number, product: Omit<IProduct, 'sku'> }>()
);


// Improve variants of product
export const ImproveVariantsProduct = createAction(
  '[ Product ] - ImproveVariantsProduct',
  props<{ variants: Omit<IVariant, 'values'>[], product?: Omit<IProduct, 'sku'>, idProduct?: number }>()
);
export const ImproveVariantsProductSuccess = createAction(
  '[ Product ] - ImproveVariantsProduct Success ',
  props<{ product: IProduct }>()
);
export const ImproveVariantsProductError = createAction(
  '[ Product ] - ImproveVariantsProduct Error',
);


// loader actions
export const SetProductLoader = createAction(
  '[ Loader ] - ShowLoader',
  props<{ isLoading: boolean }>()
);
export const SetVariantsLoader = createAction(
  '[ Loader ] - VariantsLoader',
  props<{ isLoading: boolean }>()
);

export const SetSearchProductLoader = createAction(
  '[ Loader ] - SearchLoader',
  props<{ isLoading: boolean }>()
);


// Filters
export const SetInventoryFilter = createAction(
  '[ Filters ] - SetInventoryFilter',
  props<{ keyword: string, advanced: IInventoryFilter | null }>()
);

// search
export const SetInventorySearch = createAction(
  '[ Search ] - SetInventorySearch',
  props<{ keyword: string }>()
);

// export
export const exportProducts = createAction(
  '[Product] Export Products',
  props<{ filter?: IInventoryFilterRequest | undefined; key?: string | undefined; }>()
);
export const exportProductsSuccess = createAction(
  '[Product] Export Products Success',
  props<{ file: Blob }>()
);
export const exportProductsFailure = createAction(
  '[Product] Export Products Failure',
  props<{ error: any }>()
);

// fetch products by search
export const FetchProductsBySearch = createAction(
  '[Product] Fetch Products By Search',
  props<{
    keyword?: string,
    page?: IPageCount;
    filter?: IInventoryFilterRequest | undefined;
    sort_by?: string;
    sort_mode?: string;
    priority?: number[] | undefined;
    includeDeals?: boolean; // Set to false to skip deals/pricebook data (faster for product selection)
    skipGlobalLoader?: boolean;
    append?: boolean;
  }>()
);
export const FetchProductsBySearchSuccess = createAction(
  '[Product] Fetch Products By Search Success',
  props<{ products:  APIResponse<IProduct>, append?: boolean }>()
);
export const FetchProductsBySearchError = createAction(
  '[Product] Fetch Products By Search Error',
  props<{ error: any }>()
);

// get product catalogs
export const GetProductCatalogs = createAction(
  '[ Product Catalogs ] - GetProductCatalogs',
  props<{ id?: number }>()
);
export const GetProductCatalogsSuccess = createAction(
  '[ Product Catalogs ] - GetProductCatalogs Success ',
  props<{ productCatalogs: APIResponse<IProductCatalogsData> }>()
);
export const GetProductCatalogsError = createAction(
  '[ Product Catalogs ] - GetProductCatalogs Error',
);

// update product handling units
export const UpdateProductHandlingUnits = createAction(
  '[ Product Handling Units ] - UpdateProductHandlingUnits',
  props<{ productVariantId: number; handlingUnits: any[]; mergeExisting?: boolean }>()
);
export const UpdateProductHandlingUnitsSuccess = createAction(
  '[ Product Handling Units ] - UpdateProductHandlingUnits Success '
);
export const UpdateProductHandlingUnitsError = createAction(
  '[ Product Handling Units ] - UpdateProductHandlingUnits Error',
);

// clear products
export const ClearProducts = createAction(
  '[Product] Clear Products',
);

export const SetInventorySortBy = createAction(
  '[SortBy] - SetInventorySortBy',
  props<{ key: string, mode: string }>()
);